// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { addHours as fn } from "../addHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addHoursWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default addHoursWithOptions;
